export const DomSanitizerConstants = {
    SANITIZE: 'sanitize',
    BYPASS_SECURITY_TRUST: 'bypassSecurityTrust'
};
